import React, { useEffect } from "react";

import { useAuth } from "../../hooks/useAuth";
import { useMigrationSession } from "../../hooks/useMigrationSession";

const ClarityProvider = ({ children }) => {
  const { user } = useAuth();
  const migration = useMigrationSession();

  useEffect(() => {
    if (typeof window.clarity !== "undefined") {
      if (user?.id) {
        window.clarity("set", "c2c_userId", `${user?.id}`);
      }

      if (migration?.id) {
        window.clarity("set", "c2c_migrationId", `${migration?.id}`);
      }
    }
  }, [user?.id, migration?.id]);

  return <>{children}</>;
};

export default ClarityProvider;
